"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var usePrismicCollectionInfo = function usePrismicCollectionInfo(uid, language, fetchedPrismicContent) {
  return (0, _swr["default"])([uid, language, "usePrismicCollectionInfo"], _fetcher["default"], {
    initialData: fetchedPrismicContent
  });
};
var _default = usePrismicCollectionInfo;
exports["default"] = _default;